import { useOrderStore } from '@/stores/order';
import { STATUS_PROCESSING } from '@/constants/order';

/**
 * Guard for preventing order modifications when status is 'processing'.
 * @param {Function} openCheckoutModal - Function to open the checkout modal (should be provided by the component).
 * @returns {Object} - { canModifyOrder }
 */
export function useOrderGuard(openCheckoutModal) {
  const orderStore = useOrderStore();

  /**
   * Checks if order can be modified. If not, opens checkout modal.
   * @returns {boolean}
   */
  function canModifyOrder() {
    if (orderStore.orderStatus === STATUS_PROCESSING) {
      if (typeof openCheckoutModal === 'function') {
        openCheckoutModal();
      }
      return false;
    }
    return true;
  }

  return { canModifyOrder };
}
